<template>
  
  <div id="app" class="bg-primary p100">

    <div class="container card">
      <div class="card-body pt40">
        <div style="margin:20px 0;">

          <h2>{{ titulo }}</h2>
          <br>

          <component :is="currentComponent" v-bind="componentProps"></component>

          <img src="/img/loading.gif" v-if="isSaving"/>

        </div>
      </div>
    </div>
  </div>
  
  

</template>

<script>
  import BemVindo from './components/BemVindo.vue';
  import DadosCadastrais from './components/DadosCadastrais.vue';
  import Questionario from './components/Questionario.vue';
  import Resultado from './components/Resultado.vue';

  export default {
      name: 'MainComponent',
      components: {
          BemVindo,
          DadosCadastrais,
          Questionario,
          Resultado,
      },
      data() {
          return {
              currentComponent: 'BemVindo',
              dadosCadastrais: null,
              questionario: null,
              questoes: null,
              resultado: null,
              respostas: null,
              areaAtuacao: null,
              contatoSaved: null,
              titulo: 'Diagnóstico Empresarial Resumido',
              isSaving: false,
          }
      },
      computed: {
          componentProps () {
              if (this.currentComponent === 'Questionario') {
                  return { questoes: this.questoes };
              }

              if (this.currentComponent === 'Resultado') {
                  return {
                    resultado: this.resultado,
                    contato: this.dadosCadastrais
                  };
              }

              if (this.currentComponent === 'DadosCadastrais') {
                  return { areaAtuacao: this.areaAtuacao };
              }
          }
      },
      methods: {
          showBemVindo() {
              this.currentComponent = 'BemVindo';
          },
          showDadosCadastrais () {
              this.scrollTop();
              this.currentComponent = 'DadosCadastrais';
          },
          showQuestionarios (dadosCadastrais) {
              this.scrollTop();
              this.dadosCadastrais = dadosCadastrais;
              this.currentComponent = 'Questionario';
          },
          showResultado (count, respostas) {
              this.scrollTop();
              this.resultado = count;
              this.respostas = respostas;
              this.titulo = 'Enviando...';
              this.isSaving = true;
              this.currentComponent = '';
              this.saveQuestionarioRespostas();
          },
          scrollTop () {
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;
          },
          saveQuestionarioRespostas() {
            /*console.log(JSON.stringify({
              contato: this.dadosCadastrais,
              respostas: this.respostas,
              resultado: this.resultado
            }));*/
            axios.post('/questionariodiagnostico', {
              contato: this.dadosCadastrais,
              respostas: this.respostas,
              resultado: this.resultado
            }).then(response => {
              console.log(response);
              //this.contatoSaved = response.data.contato;
              this.isSaving = false;
              this.titulo = 'Resultado do Diagnóstico Empresarial Resumido';
              this.currentComponent = 'Resultado';
            }).catch(error => {
              console.log(error.message);
            })
          }
      },
      mounted () {
          axios.get('/js/questoes.json')
          .then(response => {
              this.questoes = response.data;
          })
          .catch(error => {
              console.log(error);
          });
          axios.get('/js/areaatuacao.json')
          .then(response => {
              this.areaAtuacao = response.data;
          })
          .catch(error => {
              console.log(error);
          });
      }
  }
</script>

<style>
.side-menu {
  margin-left: 20px;
}

.main-card {
  margin: 0 20px;
}

@media only screen and (max-width: 600px) {
  .side-menu {
      margin: 0 20px;
      margin-bottom: 20px;
  }

  .main-card {
      padding-bottom: 20px;
  }
}

.centered{
  margin: 0 auto;
}
</style>
